var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-skeleton',{class:_vm.className,attrs:{"rows":_vm.rows,"animated":true,"count":_vm.count,"loading":_vm.isLoading,"throttle":_vm.throttle},scopedSlots:_vm._u([{key:"template",fn:function(){return [_vm._t("template")]},proxy:true}],null,true)},[[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }